export default class Project extends Backbone.Model
  defaults:
    persisted: false
    skill_ids: []
    topic_ids: []

  urlRoot: ->
    "/portfolio/projects"

  persisted: ->
    !@isNew()

  toJSON: ->
    { clip: @attributes }

  truncatedTitle: (maxLength = 20) ->
    title = @get("title")
    if typeof title == "undefined"
      return "your project"
    else if title.length < maxLength
      return title
    else
      return title.substring(0, maxLength) + "..."



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/models/project.js.coffee